import BaseModelInstance from './base.model'
import { RoyalRingRecipient as ModelDefinition } from './model-definitions'

class RoyalRingRecipient extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }

  // Custom methods
  isAwarded = () => {
    return !!this.get('received_at')
  }

  getRingTypeLabel = () => {
    const ringType = this.get('ring_type')
    switch (ringType) {
      case 'ceo':
        return 'Executive Race to the Royal Ring'
      case 'leader':
        return "Division Leader's Race to the Royal Ring"
      case 'agent':
        return "Agent's Race to the Royal Ring"
      default:
        return ringType
    }
  }

  getThresholdLabel = () => {
    const threshold = this.get('ring_threshold')
    if (threshold >= 1000000) {
      return `${threshold / 1000000}MM`
    } else if (threshold >= 1000) {
      return `${threshold / 1000}K`
    }
    return threshold.toString()
  }
}

export default RoyalRingRecipient
